import React, {useEffect, useState} from 'react';
import {Row, Col, Typography, Button} from 'antd';
import {getPurchaseRecord, getWaterPurchases, setWaterPurchase} from "./methods/waterPurchase.js";
import { Space, Table } from 'antd';
const { Title } = Typography;

function formatDateTime(dateTime) {
    const date = new Date(dateTime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export default function App()
{
    const [data,setData] = useState([])
    const [purchaseRecord,setPurchaseRecord] = useState([])

    function getNextPurchaser()
    {
        let index = 0;
        for(let i = 0; i < data.length; i++)
        {
            if(data[i].times < data[index].times)
            {
                index = i;
            }
        }
        return index
    }

    const columns = [
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <Title level={3}>{text}</Title>,
        },
        {
            title: '买水次数',
            dataIndex: 'times',
            key: 'times',
            render: (text) => <Title level={3}>{text}</Title>,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button type="primary"
                    onClick={
                        ()=>{
                            setWaterPurchase(
                                {
                                    name:record.name,
                                    times:record.times+1,
                                    behavior:"Purchase"
                                })
                                .then(dt => {
                                    setData(data.map(item=>{
                                        if(item.name === record.name)
                                        {
                                            return {
                                                id:item.id,
                                                name:record.name,
                                                times:record.times+1
                                            }
                                        }
                                        return item;
                                    }));
                                    setPurchaseRecord([
                                        ...purchaseRecord,
                                        {
                                            name:record.name,
                                            behavior:"Purchase",
                                            time:new Date().toISOString()
                                        }
                                    ])
                                })
                        }
                    }>买水</Button>
                    <Button type="primary"
                            onClick={
                                ()=>{
                                    if(record.times === 0)
                                    {
                                        return;
                                    }
                                    setWaterPurchase(
                                        {
                                            name:record.name,
                                            times:record.times-1,
                                            behavior:"UnPurchase"
                                        })
                                        .then(dt => {
                                            setData(data.map(item=>{
                                                if(item.name === record.name)
                                                {
                                                    return {
                                                        id:item.id,
                                                        name:record.name,
                                                        times:record.times-1
                                                    }
                                                }
                                                return item;
                                            }));
                                            setPurchaseRecord([
                                                ...purchaseRecord,
                                                {
                                                    name:record.name,
                                                    behavior:"UnPurchase",
                                                    time:new Date().toISOString()
                                                }
                                            ])
                                        })
                                }
                            }>取消买水</Button>
                </Space>
            ),
        },
    ];

    useEffect(()=>{
        getWaterPurchases()
            .then(dt => {
                setData(dt);
            })
        getPurchaseRecord()
            .then(dt => {
                console.log(dt);
                setPurchaseRecord(dt);
            })
    },[])
    return(
        <>
        <Row justify="center">
            <Col span={48}>
                <Title>下一次轮到{data[getNextPurchaser()]?.name}买水</Title>
            </Col>
        </Row>
        <Row justify="center">
            <Col span={48}>
                <Title level={2}>现在的买水次数</Title>
            </Col>
        </Row>
        <Row justify="center">
            <Col span={24}>
                <Table columns={columns} dataSource={data} />
            </Col>
        </Row>
        <Row justify="center">
            <Col span={48}>
                <Title level={2}>最近买水</Title>
            </Col>
        </Row>
            {
                [...purchaseRecord].reverse().map((item, index) => {
                    return (
                        <Row justify="center" key={index}>
                            <Col span={24} style={{
                                textAlign: 'center',
                            }}>
                                <Title level={4}>时间{formatDateTime(item.time)} : {item.name}{(item.behavior === 'Purchase') ? "买了一桶水" : "取消了买水"} </Title>
                            </Col>
                        </Row>
                    );
                })
            }
        </>
    )
}